




import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'GlobalProgressBar',
    computed: {
        ...mapGetters('loaderModule', [
            'loading'
        ])
    },
    data() {
        return {
            progress: 0,
            progressBarActive: false
        };
    },
    methods: {
        startProgressBar() {
            if (!this.progressBarActive) {
                this.progressBarActive = true;
                this.progress = 0;

                const maxProgressIncrement = 5;
                const maxSkipCount = 3;
                const intervalLength = 1000;
                let skipCount = 0;

                const getProgressIncrement = (currentProgress: number) => {
                    let progressIncrement = (100 - currentProgress) / 2;
                    progressIncrement = Math.floor(progressIncrement * Math.random());

                    if (progressIncrement > maxProgressIncrement) {
                        progressIncrement = maxProgressIncrement;
                    }

                    return progressIncrement;
                };

                const interval = setInterval(() => {
                    let skip = Math.random() >= .5;

                    if (skip) {
                        skipCount++;
                    }

                    if (skipCount > maxSkipCount) {
                        skip = false;
                    }

                    if (!skip && this.loading) {
                        skipCount = 0;

                        this.progress += getProgressIncrement(this.progress);
                    }
                    else if (!this.loading) {
                        clearInterval(interval);

                        this.finishProgressBar();
                    }
                }, intervalLength);

            }
        },
        finishProgressBar() {
            this.progressBarActive = false;
            this.progress = 100;

            setTimeout(() => {
                if (!this.progressBarActive) {
                    this.progress = 0;
                }
            }, 500);
        }
    },
    async mounted() {
        this.startProgressBar();
    },
    watch: {
        loading: {
            handler(val, oldVal) {
                if (val) {
                    this.startProgressBar();
                }
            },
            deep: true
        }
    }
});
